import { SET_ACTIVE_PERIOD } from "./mutation_types";

export default {
  async [SET_ACTIVE_PERIOD]({ commit }, payload) {
    commit(SET_ACTIVE_PERIOD, payload);
  }
};
